import { useContext, useRef } from 'react';
import { PluginContext } from 'ts-components/Plugins/context';
import { floatingFrameId } from 'ts-components/Plugins/floatingFrameRegistry';
import { nextPaint } from 'ts-components/PiChat/capture/captureElement';
import { sendResultUpload } from 'ts-components/PiChat/presignedPut';
import { useFrameHandler } from '../useFrameHandler';
import {
  createKiCodeOpenFloatingFrame,
  floatingFrameView,
} from './openFloatingFrame';

/** `appApiName` is read when each frame is handled, so it must return the session's live binding. */
export const useKiCodeOpenFloatingFrame = (
  enabled: boolean,
  appApiName: () => string | undefined
) => {
  const { floatingFrames } = useContext(PluginContext);
  const latest = useRef({ floatingFrames, appApiName });
  latest.current = { floatingFrames, appApiName };

  return useFrameHandler(enabled, () =>
    createKiCodeOpenFloatingFrame({
      appApiName: () => latest.current.appApiName(),
      listed: (id) =>
        latest.current.floatingFrames.some(
          (frame) =>
            floatingFrameId(frame.plugin_api_name, frame.api_name) === id
        ),
      view: floatingFrameView,
      sendResult: sendResultUpload,
      nextPaint,
      now: () => Date.now(),
    })
  ).handle;
};
